// extracted by mini-css-extract-plugin
module.exports = {"root":"hub-card-skeleton_root__lTorT","featured":"hub-card-skeleton_featured__CFYHD"};